<template>
  <div class="frisbuy-summary-widget__ai-wrapper">
    <span> {{ props.text }} </span> &nbsp;
    <div
      class="frisbuy-summary-widget__ai-wrapper--link"
      @click="emit('swipeToMarket')"
    >
      {{ props.count }} {{ props.anchorText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  text?: string;
  count?: number;
  anchorText?: string;
}>();
const emit = defineEmits(["swipeToMarket"]);
</script>
